import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, shareReplay } from 'rxjs';
import { Product } from '../models/product';

@Injectable({ providedIn: 'root' })
export class ProductsService {
  private readonly http = inject(HttpClient);

  private readonly products$ = this.http.get<Product[]>('data/products.json').pipe(shareReplay(1));

  getAll(): Observable<Product[]> {
    return this.products$;
  }

  getBySlug(slug: string): Observable<Product | undefined> {
    return this.products$.pipe(map((products) => products.find((p) => p.slug === slug)));
  }
}
